import { NavLinkItem } from './NavBar.types';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import HomeIcon from '@mui/icons-material/Home';

export const navComunLinks: NavLinkItem[] = [
  {
    title: "Home",
    path: "/",
    icon: <HomeIcon />
  }
];

export const navAdminLinks: NavLinkItem[] = [
  {
    title: "Avanzado",
    path: "/avanzado",
    icon: <SettingsApplicationsIcon />
  },
  {
    title: "Registrar",
    path: "/registrar",
    icon: <ManageAccountsIcon />
  }
];
